module.exports = __webpack_public_path__ + "static/img/case1-bg.e6b5c11.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case1-bg.webp
// module id = EChG
// module chunks = 0